import { useMemo } from 'react'

import { CollectionUUID } from '@library/menu-service'

import { useCollection } from './useCollection'

export const useCollectionRecipeIds = (id: CollectionUUID | null): string[] | null => {
  const collection = useCollection(id)

  return useMemo(() => {
    if (!collection) {
      return null
    }

    return collection.recipes.map((recipe) => recipe.id)
  }, [collection])
}
